/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Event_Group_B_LabelInputs */



/**
* | output |
* | --- |
* | "Event Group B:" |
*
* @param {Compare_Event_Groups_Event_Group_B_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_event_group_b_label = /** @type {((inputs?: Compare_Event_Groups_Event_Group_B_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Event_Group_B_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupe d'événements B :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltungsgruppe B:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gruppo di eventi B:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Группа мероприятий B:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Grupo de eventos B:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("B组活动：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループB:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट ग्रुप बी:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Grupo de Eventos B:")
	return /** @type {LocalizedString} */ ("Event Group B:")
});